<template>
  <div class="form">
    <div class="form-item">
      <span class="label">原保单号</span>
      <span class="value">{{ formData.policyNo }}</span>
    </div>

    <div class="form-item">
      <span class="label">产品名称</span>
      <span class="value">{{ formData.productName }}（{{ formData.productCode }}）</span>
    </div>

    <div class="form-item">
      <span class="label">保险公司</span>
      <span class="value">{{ formData.companyName }}</span>
    </div>

    <div class="form-item">
      <span class="label">新保单号</span>
      <span class="value link" v-if="formData.newPolicyNo" @click="goPolicyDetail">{{ formData.newPolicyNo }}</span>
      <span class="value" v-else>-</span>
    </div>

    <div class="form-item">
      <span class="label">原保单状态</span>
      <span class="value">{{ formData.policyStatusDesc }}</span>
    </div>

    <div class="form-item">
      <span class="label">保单到期日</span>
      <span class="value">{{ filterTime(formData.endTime, 'YYYY-MM-DD') }}</span>
    </div>

    <div class="form-item">
      <span class="label">续保状态</span>
      <span class="value">{{ formData.payState | filterStatus }}</span>
    </div>
    <div class="form-item">
      <span class="label">保单生效日</span>
      <span class="value">{{ filterTime(formData.startTime, 'YYYY-MM-DD') }}</span>
    </div>

    <div class="form-item">
      <span class="label">原单保费(元)</span>
      <span class="value">{{ formData.fee }}</span>
    </div>

    <div class="form-item">
      <span class="label">续保保费(元)</span>
      <span class="value">{{ formData.payFee || '-' }}</span>
    </div>

    <div class="form-item">
      <span class="label">原单服务费(元)</span>
      <span class="value">{{ formData.commissionPrice }}</span>
    </div>
    <div class="form-item">
      <span class="label">新单服务费(元)</span>
      <span class="value">{{ formData.newCommissionPrice }}</span>
    </div>

    <div class="form-item" v-if="$units.superviseShowVal() && $units.pointAction('renewalManage_04_10')">
      <span class="label">供应商</span>
      <span class="value">{{ formData.supplierName }}</span>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  props: {
    // 列表详情
    formData: {
      default: () => {},
      type: Object
    }
  },

  filters: {
    filterNull(val) {
      if (!val) {
        return '-';
      }
      return val;
    },


    // 续保状态
    filterStatus(num) {
      const m = new Map([
        ['1', '即将到期'],
        ['2', '已续保'],
        ['3', '未续保']
      ]);
      return m.get(num + '');
    }
  },

  methods: {
    //日期处理
    filterTime(val, format) {
      if (!val) {
        return '-';
      }
      if (val) {
        format = format || 'YYYY-MM-DD HH:mm:ss';
        return dayjs(val).format(format);
      }
    },
    // 跳转保单列表
    goPolicyDetail() {
      this.$router.push({
        path: '/orderManage/group/policyDetail',
        query: {
          backUrl: this.delQueStr(this.$route.fullPath, 'time'),
          id: this.formData.newId || '',
          policyNo: this.formData.newPolicyNo,
          orderNo: this.formData.orderId,
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  margin: 20px 0 30px 0;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  .form-item {
    margin-bottom: 15px;
    display: flex;
    width: 25%;
    .label {
      width: 120px;
      white-space: nowrap;
      display: block;
      text-align: right;
      margin-right: 20px;
      font-size: 14px;
      color: #666e7b;
    }
    .value {
      width: 80%;
      color: #272933;
      &.link {
        cursor: pointer;
        color: #236dff;
      }
    }
  }
}
</style>